import { Certificate, ServicePillar, TrainingCourse, Testimonial } from '../types';

export const initialCertificates: Certificate[] = [
  {
    id: 'CHC-2025-ISO9001-0842',
    recipientName: 'Karim Benali',
    recipientEmail: 'karim.benali@sonatrach.dz',
    recipientCompany: 'Sonatrach Exploration & Production',
    courseTitle: {
      fr: 'Auditeur Principal de Systèmes de Management de la Qualité (ISO 9001:2015)',
      en: 'Quality Management Systems Lead Auditor (ISO 9001:2015)',
      ar: 'رئيس مدققي أنظمة إدارة الجودة (ISO 9001:2015)',
    },
    standardCode: 'ISO 9001:2015',
    category: 'iso',
    issueDate: '2025-01-15',
    expiryDate: '2028-01-14',
    grade: 'Mention Très Bien / Avec Félicitations du Jury',
    status: 'active',
    leadAuditor: 'Chérif Haddad (Lead Auditor IRCA & Senior Expert)',
    certificateHash: 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
    skillsAcquired: [
      'Planification et conduite d\'audits tierce-partie',
      'Maîtrise des exigences de la norme ISO 9001:2015',
      'Rédaction de rapports de non-conformité et plans d\'actions',
      'Évaluation de l\'approche par les risques',
    ],
    issuedLocation: 'Paris / Alger',
  },
  {
    id: 'CHC-2024-HSE-0199',
    recipientName: 'Sarah Dupont-Lefèvre',
    recipientEmail: 's.dupont@totalenergies.com',
    recipientCompany: 'TotalEnergies Renewables',
    courseTitle: {
      fr: 'Management de la Santé, Sécurité au Travail & Environnement (ISO 45001 & ISO 14001)',
      en: 'Occupational Health, Safety & Environmental Management (ISO 45001 & ISO 14001)',
      ar: 'إدارة الصحة والسلامة المهنية والبيئة (ISO 45001 & ISO 14001)',
    },
    standardCode: 'ISO 45001:2018 / ISO 14001:2015',
    category: 'hse',
    issueDate: '2024-11-20',
    expiryDate: '2027-11-19',
    grade: 'Mention Distinction / 96/100',
    status: 'active',
    leadAuditor: 'Chérif Haddad (Lead Auditor IRCA & Senior Expert)',
    certificateHash: '8f434346648f6b96df89dda901c5176b10a6d83961dd3c1ac88b59b2dc327aa4',
    skillsAcquired: [
      'Analyse des risques industriels et document unique',
      'Gestion des situations d\'urgence et enquêtes accidents',
      'Mesure des impacts environnementaux et conformité légale',
    ],
    issuedLocation: 'Paris, France',
  },
  {
    id: 'CHC-2025-ISPS-0310',
    recipientName: 'Capitaine Amine Meziane',
    recipientEmail: 'a.meziane@port-alger.dz',
    recipientCompany: 'Entreprise Portuaire d\'Alger (EPAL)',
    courseTitle: {
      fr: 'Agent de Sûreté de l\'Installation Portuaire (ASIP) & Code ISPS OMI',
      en: 'Port Facility Security Officer (PFSO) & IMO ISPS Code',
      ar: 'مسؤول أمن المنشأة المينائية (PFSO) والمدونة الدولية لأمن السفن والموانئ ISPS',
    },
    standardCode: 'IMO / ISPS Code Class VI',
    category: 'maritime',
    issueDate: '2025-02-02',
    expiryDate: '2030-02-01',
    grade: 'Mention Excellence Opérationnelle',
    status: 'active',
    leadAuditor: 'Chérif Haddad (Expert Maritime & Portuaire OMI)',
    certificateHash: '3a7bd3e2360a3d29eea436fcfb7e44c735d117c42d1c1835420b6b9942dd4f1b',
    skillsAcquired: [
      'Évaluation de la sûreté des installations portuaires (ESIP)',
      'Élaboration du Plan de Sûreté de l\'Installation Portuaire (PSIP)',
      'Gestion des niveaux de sûreté 1, 2 et 3 et exercices d\'urgence',
    ],
    issuedLocation: 'Alger, Algérie',
  },
  {
    id: 'CHC-2024-ISO27001-0721',
    recipientName: 'Dr. Mehdi El-Mansouri',
    recipientEmail: 'm.mansouri@gulf-banking.ae',
    recipientCompany: 'Emirates Islamic Financial Group',
    courseTitle: {
      fr: 'Lead Implementer en Sécurité de l\'Information & Cybergouvernance (ISO/IEC 27001:2022)',
      en: 'Information Security Lead Implementer & Cyber Governance (ISO/IEC 27001:2022)',
      ar: 'كبير مسؤولي تطبيق أمن المعلومات والحوكمة السيبرانية (ISO/IEC 27001:2022)',
    },
    standardCode: 'ISO/IEC 27001:2022',
    category: 'management',
    issueDate: '2024-09-10',
    expiryDate: '2027-09-09',
    grade: 'Mention Très Honorable',
    status: 'active',
    leadAuditor: 'Chérif Haddad (Senior Lead Auditor)',
    certificateHash: 'bc45001d8c19987cfbe27bb61c77f0a82d02c4187f58dcf400b12f27ebae4f91',
    skillsAcquired: [
      'Déploiement d\'un SMSI selon ISO 27001:2022',
      'Déclaration d\'applicabilité (SoA) et matrice des risques',
      'Continuité d\'activité informatique et gestion des incidents',
    ],
    issuedLocation: 'Dubai, UAE',
  },
  {
    id: 'CHC-2023-LEAN-0054',
    recipientName: 'Nadia Larbi',
    recipientEmail: 'n.larbi@renault-algerie.com',
    recipientCompany: 'Renault Trucks Production Hub',
    courseTitle: {
      fr: 'Ceinture Verte Lean Six Sigma (Green Belt) & Optimisation des Processus',
      en: 'Lean Six Sigma Green Belt & Process Excellence',
      ar: 'الحزام الأخضر في لين 6 سيجما وتحسين العمليات الإنتاجية',
    },
    standardCode: 'IASSC / ISO 18404',
    category: 'lean',
    issueDate: '2023-03-12',
    expiryDate: '2026-03-11',
    grade: 'Mention Bien',
    status: 'active',
    leadAuditor: 'Chérif Haddad (Master Black Belt & Senior Consultant)',
    certificateHash: '9a87ff0231846b4e8574ac6e36d418bc27ef3209bbd664539659b87a8f844a1e',
    skillsAcquired: [
      'Méthodologie DMAIC et cartographie VSM',
      'Analyse statistique des variations et capabilité processus',
      'Chantiers Kaizen et élimination des 8 gaspillages (Muda)',
    ],
    issuedLocation: 'Tunis / Alger',
  },
  {
    id: 'CHC-2024-AUDIT-9912',
    recipientName: 'Jean-Marc Fontaine',
    recipientEmail: 'jm.fontaine@demo-test.fr',
    recipientCompany: 'Ex-Société Audit International',
    courseTitle: {
      fr: 'Auditeur Interne Intégré QSE (Qualité, Sécurité, Environnement)',
      en: 'Integrated QSE Internal Auditor (Quality, Safety, Environment)',
      ar: 'مدقق داخلي متكامل للجودة والسلامة والبيئة QSE',
    },
    standardCode: 'ISO 19011 / SMI',
    category: 'audit',
    issueDate: '2024-01-10',
    expiryDate: '2025-01-09',
    grade: 'Document Annulé',
    status: 'revoked',
    leadAuditor: 'Chérif Haddad (Lead Auditor)',
    certificateHash: '5e884898da28047151d0e56f8dc6292773603d0d6aabbdd62a11ef721d1542d8',
    skillsAcquired: ['Certification révoquée suite à invalidation administrative.'],
    issuedLocation: 'Paris, France',
  },
];

export const servicePillars: ServicePillar[] = [
  {
    id: 'iso-certification',
    icon: 'Award',
    title: {
      fr: 'Systèmes de Management & Normes ISO',
      en: 'Management Systems & ISO Standards',
      ar: 'أنظمة الإدارة ومعايير الآيزو الدولية',
    },
    subtitle: {
      fr: 'Accompagnement à la certification, mise en place et maintien des référentiels internationaux.',
      en: 'Certification guidance, implementation, and maintenance of global standards.',
      ar: 'المرافقة للحصول على شهادات المطابقة الدولية وتطبيق النظم الإدارية الحديثة.',
    },
    description: {
      fr: 'Notre cabinet vous guide de l\'état des lieux initial jusqu\'à l\'audit de certification finale. Nous structurons des systèmes agiles, centrés sur la création de valeur et l\'amélioration continue.',
      en: 'From baseline gap analysis to final certification audit, our firm builds agile management frameworks centered on measurable value creation and sustainable improvement.',
      ar: 'يرافقكم مكتبنا من مرحلة التشخيص الأولي وحتى التدقيق النهائي للاعتماد. نبني أنظمة إدارية مرنة تركز على خلق القيمة والتحسين المستمر.',
    },
    features: {
      fr: [
        'ISO 9001 (Système de Management de la Qualité)',
        'ISO 14001 (Management Environnemental)',
        'ISO 45001 (Santé & Sécurité au Travail)',
        'ISO 27001 (Sécurité des Systèmes d\'Information)',
        'ISO 22000 & FSSC 22000 (Sécurité des Denrées Alimentaires)',
        'ISO 50001 (Management de l\'Énergie)',
      ],
      en: [
        'ISO 9001 (Quality Management Systems)',
        'ISO 14001 (Environmental Management)',
        'ISO 45001 (Occupational Health & Safety)',
        'ISO 27001 (Information Security Management)',
        'ISO 22000 & FSSC 22000 (Food Safety)',
        'ISO 50001 (Energy Management)',
      ],
      ar: [
        'ISO 9001 (نظام إدارة الجودة)',
        'ISO 14001 (نظام الإدارة البيئية)',
        'ISO 45001 (نظام إدارة الصحة والسلامة المهنية)',
        'ISO 27001 (أمن وسرية المعلومات والبيانات)',
        'ISO 22000 (سلامة الغذاء والصناعات الغذائية)',
        'ISO 50001 (إدارة وترشيد الطاقة)',
      ],
    },
    standards: ['ISO 9001', 'ISO 14001', 'ISO 45001', 'ISO 27001', 'ISO 50001'],
  },
  {
    id: 'strategic-consulting',
    icon: 'TrendingUp',
    title: {
      fr: 'Conseil Stratégique & Gouvernance',
      en: 'Strategic Consulting & Governance',
      ar: 'الاستشارات الاستراتيجية والحوكمة المؤسسية',
    },
    subtitle: {
      fr: 'Optimisation organisationnelle, restructuration, gestion du changement et performance globale.',
      en: 'Organizational optimization, restructuring, change management, and overall performance.',
      ar: 'إعادة الهيكلة، تحسين الأداء المؤسسي، إدارة التغيير والتميز القيادي.',
    },
    description: {
      fr: 'Nous accompagnons les comités de direction et conseils d\'administration dans l\'élaboration de plans stratégiques, la cartographie des risques majeurs et la gouvernance d\'entreprise.',
      en: 'We assist boards of directors and executive committees in crafting corporate strategy, risk roadmaps, and high-performance corporate governance frameworks.',
      ar: 'نرافق مجالس الإدارة والقيادات التنفيذية في صياغة الخطط الاستراتيجية، رسم خرائط المخاطر الكبرى وترسيخ مبادئ الحوكمة الرشيدة.',
    },
    features: {
      fr: [
        'Diagnostic stratégique et organisationnel 360°',
        'Cartographie des risques et Continuité d\'Activité (ISO 31000 & ISO 22301)',
        'Optimisation des processus et réduction des coûts (Lean Management)',
        'Déploiement des démarches RSE / ESG et durabilité',
      ],
      en: [
        '360° Strategic and Organizational Assessment',
        'Enterprise Risk Mapping & Business Continuity (ISO 31000 & ISO 22301)',
        'Process Optimization & Lean Cost Rationalization',
        'CSR / ESG & Sustainability Strategy Deployment',
      ],
      ar: [
        'التشخيص المؤسسي والاستراتيجي الشامل 360 درجة',
        'خريطة المخاطر واستمرارية الأعمال (ISO 31000 & ISO 22301)',
        'هندسة العمليات والتحسين المستمر وفق منهجية لين',
        'تطبيق معايير المسؤولية المجتمعية والحوكمة البيئية ESG',
      ],
    },
  },
  {
    id: 'maritime-logistics',
    icon: 'Anchor',
    title: {
      fr: 'Expertise Maritime, Portuaire & Sûreté ISPS',
      en: 'Maritime, Ports & ISPS Security Expertise',
      ar: 'الخبرة الملاحية، الموانئ والأمن البحري ISPS',
    },
    subtitle: {
      fr: 'Expertise maritime internationale, sûreté des navires et installations portuaires (Code ISPS OMI).',
      en: 'International maritime consulting, vessel and port facility security (IMO ISPS Code).',
      ar: 'استشارات بحرية متخصصة، أمن المنشآت المينائية والسفن وفق مدونة ISPS الدولية.',
    },
    description: {
      fr: 'Spécialiste agréé des réglementations maritimes internationales de l\'Organisation Maritime Internationale (OMI). Évaluations de sûreté (ESIP), plans de sûreté portuaire (PSIP) et audits maritimes de conformité.',
      en: 'Accredited specialist in International Maritime Organization (IMO) conventions. Port facility security assessments (PFSA), security plans (PFSP), and maritime compliance audits.',
      ar: 'خبرة معتمدة في الاتفاقيات واللوائح البحرية الصادرة عن المنظمة البحرية الدولية (IMO). تقييم أمن المنشآت المينائية وإعداد خطط الأمن البحري والتدقيق الميداني.',
    },
    features: {
      fr: [
        'Élaboration et révision des Plans de Sûreté Portuaire (PSIP / Code ISPS)',
        'Audits de sûreté des terminaux conteneurs, hydrocarbures et vrac',
        'Formation qualifiante ASIP / PFSO et exercices de simulation d\'urgence',
        'Expertise en logistique portuaire et flux de transport maritime',
      ],
      en: [
        'Port Facility Security Plans (PFSP / ISPS Code) formulation & audit',
        'Security audits for container, bulk, and oil & gas terminals',
        'PFSO qualification training and emergency scenario simulations',
        'Port logistics, stevedoring, and maritime shipping flux expertise',
      ],
      ar: [
        'إعداد ومراجعة خطط أمن المنشآت المينائية (PSIP / مدونة ISPS)',
        'تدقيق أمن محطات الحاويات، المحروقات والبضائع العامة',
        'تأهيل مسؤولي أمن المنشآت المينائية (PFSO) وتمارين المحاكاة',
        'استشارات سلاسل الإمداد والخدمات اللوجستية للنقل البحري',
      ],
    },
  },
  {
    id: 'hse-industrial-safety',
    icon: 'ShieldCheck',
    title: {
      fr: 'HSE & Sécurité Industrielle Avancée',
      en: 'HSE & Industrial Safety Engineering',
      ar: 'الصحة والسلامة المهنية والأمن الصناعي HSE',
    },
    subtitle: {
      fr: 'Prévention des risques majeurs, études de dangers, conformité réglementaire et culture sécurité.',
      en: 'Major hazard prevention, risk modeling, regulatory compliance, and safety culture development.',
      ar: 'الوقاية من الحوادث الكبرى، دراسات الأخطار، الامتثال التشريعي وثقافة السلامة.',
    },
    description: {
      fr: 'Nous aidons les sites industriels complexes (pétrole, chimie, métallurgie, BTP, énergie) à instaurer une culture « Zéro Accident » et à maîtriser leurs risques technologiques.',
      en: 'We empower complex industrial facilities (oil & gas, chemicals, heavy industry, construction, energy) to achieve "Zero Accident" milestones and mitigate major technological hazards.',
      ar: 'نساعد المنشآت الصناعية الكبرى (النفط والغاز، البتروكيماويات، الطاقة والبناء) في غرس ثقافة "صفر حادث" والتحكم الصارم في المخاطر التكنولوجية.',
    },
    features: {
      fr: [
        'Études d\'impact environnemental et études de dangers (EDD)',
        'Plans d\'Opération Interne (POI) et Plans d\'Urgence (PPI)',
        'Audits de conformité réglementaire Hygiène, Sécurité et Environnement',
        'Évaluation ergonomique des postes et santé au travail',
      ],
      en: [
        'Environmental Impact Assessments (EIA) & Hazard Studies',
        'Internal Emergency Plans & Crisis Management Frameworks',
        'HSE Legal & Regulatory Compliance Audits',
        'Workstation Ergonomics & Occupational Health Surveys',
      ],
      ar: [
        'دراسات التأثير البيئي ودراسات الأخطار الصناعية',
        'إعداد خطط الطوارئ والتدخل الداخلي للمنشآت (POI)',
        'تدقيق الامتثال للتشريعات الوطنية والدولية للسلامة والبيئة',
        'تقييم بيئة العمل والوقاية من الأمراض المهنية',
      ],
    },
  },
  {
    id: 'compliance-audits',
    icon: 'ClipboardCheck',
    title: {
      fr: 'Audits & Diagnostics de Conformité',
      en: 'Compliance & Diagnostic Audits',
      ar: 'التدقيق الشامل وتشخيص المطابقة',
    },
    subtitle: {
      fr: 'Audits à blanc, audits fournisseurs, audits de pré-certification et revues de processus.',
      en: 'Mock audits, supply chain audits, pre-certification reviews, and process assessments.',
      ar: 'التدقيق التجريبي، تدقيق الموردين وسلاسل الإمداد، وتدقيق ما قبل الاعتماد الرسمي.',
    },
    description: {
      fr: 'Bénéficiez du regard objectif et expérimenté d\'un Lead Auditor certifié IRCA pour identifier vos écarts, consolider vos points forts et garantir le succès de vos audits officiels.',
      en: 'Leverage the unbiased, battle-tested expertise of an IRCA-certified Lead Auditor to pinpoint non-conformities, reinforce strengths, and secure first-pass certification success.',
      ar: 'استفيدوا من الرؤية الموضوعية والخبرة العميقة لرئيس مدققين معتمد لضبط الفجوات وتعزيز نقاط القوة وضمان النجاح المؤكد في التدقيق الرسمي.',
    },
    features: {
      fr: [
        'Audits à blanc avant certification ISO avec rapport détaillé',
        'Audits de seconde partie (évaluation et qualification des fournisseurs)',
        'Audits internes externalisés pour PME et grands comptes',
        'Accompagnement à la levée des non-conformités majeures et mineures',
      ],
      en: [
        'Mock pre-certification audits with comprehensive gap reports',
        'Second-party audits (supplier qualification and tier assessment)',
        'Outsourced internal audit campaigns for corporate leaders',
        'Post-audit corrective action planning and closure guidance',
      ],
      ar: [
        'تدقيق تجريبي شامل قبل الاعتماد مع تقرير تفصيلي',
        'تدقيق الطرف الثاني لتقييم وتأهيل الموردين والمتعاملين',
        'تنفيذ حملات التدقيق الداخلي بالنيابة عن الشركات',
        'المرافقة لمعالجة حالات عدم المطابقة وتطبيق الإجراءات التصحيحية',
      ],
    },
  },
  {
    id: 'executive-training',
    icon: 'GraduationCap',
    title: {
      fr: 'Formations Certifiantes & Transfert de Compétences',
      en: 'Executive Certification & Skill Transfer',
      ar: 'التدريب الاحترافي والتأهيل ونقل الخبرات',
    },
    subtitle: {
      fr: 'Formations diplômantes, séminaires exécutifs et délivrance de certificats officiels sécurisés.',
      en: 'Certified executive seminars, corporate academies, and issuance of tamper-proof credentials.',
      ar: 'برامج تدريبية تخصصية، ورشات للقيادات وتسليم شهادات معتمدة مشفرة برمز QR.',
    },
    description: {
      fr: 'Des parcours pédagogiques d\'élite alliant apports théoriques de haut niveau, études de cas industrielles réelles et simulations d\'audits pour des compétences immédiatement opérationnelles.',
      en: 'Elite learning roadmaps pairing world-class theoretical frameworks with hands-on industrial case studies and live audit simulations for immediate operational mastery.',
      ar: 'مسارات تدريبية نخبوية تجمع بين المفاهيم النظرية المتقدمة، دراسة الحالات الواقعية والمحاكاة الميدانية لاكتساب كفاءة عملية فورية.',
    },
    features: {
      fr: [
        'Cursus Auditeur / Lead Auditor certifié (IRCA)',
        'Délivrance de certificats numériques infalsifiables avec QR Code',
        'Formations sur-mesure en intra-entreprise adaptées à vos métiers',
        'Sessions interactives en présentiel ou en classe virtuelle immersive',
      ],
      en: [
        'Certified Auditor / Lead Auditor pathways (IRCA syllabus)',
        'Tamper-proof digital certificates issued with live QR verification',
        'Tailored in-house enterprise sessions mapped to your industry',
        'High-impact classroom delivery and interactive virtual bootcamps',
      ],
      ar: [
        'مسارات تأهيل المدققين ورؤساء المدققين المعتمدين',
        'تسليم شهادات رقمية مؤمنة وموثقة برمز QR مشفر',
        'دورات تدريبية مخصصة داخل الشركات وفق متطلبات كل قطاع',
        'جلسات تدريبية حضورية وتدريب افتراضي تفاعلي عالي الجودة',
      ],
    },
  },
];

export const trainingCourses: TrainingCourse[] = [
  {
    id: 'lead-auditor-9001',
    category: 'iso',
    duration: '5 Jours (40h)',
    format: 'hybrid',
    level: 'lead-auditor',
    nextSessionDate: '15 - 19 Avril 2025',
    title: {
      fr: 'Auditeur Principal / Lead Auditor ISO 9001:2015 (Qualité)',
      en: 'ISO 9001:2015 Lead Auditor (Quality Management Systems)',
      ar: 'رئيس مدققي أنظمة إدارة الجودة ISO 9001:2015',
    },
    description: {
      fr: 'Formation d\'excellence pour maîtriser la conduite d\'audits de systèmes de management de la qualité selon les lignes directrices ISO 19011 et ISO 17021.',
      en: 'Executive masterclass to master conducting third-party quality management audits according to ISO 19011 & ISO 17021 standards.',
      ar: 'دورة تدريبية احترافية للتمكن من قيادة وتسيير عمليات تدقيق أنظمة إدارة الجودة وفق معايير ISO 19011 و ISO 17021.',
    },
    objectives: {
      fr: [
        'Comprendre et interpréter en profondeur les exigences ISO 9001:2015',
        'Planifier, préparer et mener des audits de certification',
        'Formuler des constats d\'audit précis et argumentés',
        'Rédiger des rapports d\'audit conformes aux exigences IRCA',
      ],
      en: [
        'Thoroughly interpret ISO 9001:2015 requirements',
        'Plan, schedule, and execute full certification audits',
        'Draft rigorous, evidence-based audit findings',
        'Produce audit reports conforming to IRCA standards',
      ],
      ar: [
        'فهم واستيعاب بنود ومتطلبات المواصفة القياسية ISO 9001:2015',
        'تخطيط وتنفيذ وإدارة عمليات التدقيق الشاملة',
        'صياغة تقارير عدم المطابقة والملاحظات بدقة',
        'إعداد التقارير الختامية للتدقيق وفق أفضل الممارسات الدولية',
      ],
    },
    targetAudience: {
      fr: 'Directeurs Qualité, Responsables QHSE, Consultants, Auditeurs internes et Cadres dirigeants.',
      en: 'Quality Directors, QHSE Managers, Senior Consultants, Internal Auditors, and Executives.',
      ar: 'مدراء الجودة، مسؤولو السلامة والبيئة، المستشارون والمدققون الداخليون.',
    },
  },
  {
    id: 'lead-auditor-45001',
    category: 'hse',
    duration: '5 Jours (40h)',
    format: 'presentiel',
    level: 'lead-auditor',
    nextSessionDate: '05 - 09 Mai 2025',
    title: {
      fr: 'Auditeur Principal ISO 45001:2018 (Santé & Sécurité au Travail)',
      en: 'ISO 45001:2018 Lead Auditor (Occupational Health & Safety)',
      ar: 'رئيس مدققي أنظمة إدارة الصحة والسلامة المهنية ISO 45001:2018',
    },
    description: {
      fr: 'Devenez auditeur certifié pour évaluer la conformité et l\'efficacité des dispositifs de santé et sécurité au travail dans l\'industrie et les services.',
      en: 'Become a certified auditor evaluating the compliance and effectiveness of OH&S management systems in industrial and corporate environments.',
      ar: 'تأهيل مدققين معتمدين لتقييم كفاءة ومطابقة أنظمة إدارة الصحة والسلامة المهنية في المؤسسات الصناعية والخدمية.',
    },
    objectives: {
      fr: [
        'Identifier les dangers et maîtriser l\'évaluation des risques SST',
        'Auditer la consultation et participation des travailleurs',
        'Évaluer la conformité réglementaire et la gestion des situations d\'urgence',
      ],
      en: [
        'Identify hazards and assess occupational safety risks',
        'Audit worker consultation and participation frameworks',
        'Evaluate legal compliance and emergency response readiness',
      ],
      ar: [
        'تحديد المخاطر وتقييم تدابير الوقاية من الحوادث المهنية',
        'تدقيق آليات مشاركة واستشارة العمال في منظومة السلامة',
        'تقييم الامتثال للقوانين المعمول بها والجاهزية للطوارئ',
      ],
    },
    targetAudience: {
      fr: 'Responsables HSE, Ingénieurs sécurité, Médecins du travail, Auditeurs d\'entreprises.',
      en: 'HSE Directors, Industrial Safety Engineers, Occupational Health Officers, Corporate Auditors.',
      ar: 'مدراء ومسؤولو السلامة والصحة المهنية، مهندسو الوقاية، وأطباء العمل.',
    },
  },
  {
    id: 'pfso-isps-maritime',
    category: 'maritime',
    duration: '4 Jours (32h)',
    format: 'presentiel',
    level: 'expert',
    nextSessionDate: '19 - 22 Mai 2025',
    title: {
      fr: 'Agent de Sûreté de l\'Installation Portuaire (ASIP / PFSO - Code ISPS)',
      en: 'Port Facility Security Officer (PFSO / ISPS Code Certification)',
      ar: 'تأهيل مسؤول أمن المنشأة المينائية (ASIP / PFSO - مدونة ISPS الدولية)',
    },
    description: {
      fr: 'Formation réglementaire obligatoire selon les directives de l\'Organisation Maritime Internationale (OMI) pour la désignation des officiers de sûreté portuaire.',
      en: 'Mandatory IMO regulatory training for the appointment and certification of Port Facility Security Officers.',
      ar: 'دورة تدريبية إلزامية معتمدة وفق تعليمات المنظمة البحرية الدولية OMI لتأهيل مسؤولي الأمن المينائي.',
    },
    objectives: {
      fr: [
        'Maîtriser les dispositions du Chapitre XI-2 de la Convention SOLAS et du Code ISPS',
        'Conduire l\'Évaluation de Sûreté de l\'Installation Portuaire (ESIP)',
        'Rédiger, mettre en œuvre et auditer le Plan de Sûreté (PSIP)',
        'Gérer les contrôles d\'accès, la vidéosurveillance et la riposte aux menaces maritimes',
      ],
      en: [
        'Master SOLAS Chapter XI-2 provisions and ISPS Code Parts A & B',
        'Execute Port Facility Security Assessments (PFSA)',
        'Draft, implement, and maintain the Port Facility Security Plan (PFSP)',
        'Manage access control, perimeter security, and maritime threat response',
      ],
      ar: [
        'استيعاب متطلبات اتفاقية SOLAS والمدونة الدولية لأمن السفن والموانئ ISPS',
        'إجراء التقييم الأمني للمنشآت والمحطات المينائية',
        'إعداد وتطبيق وتحديث خطة أمن المنشأة المينائية',
        'إدارة أنظمة المراقبة والتحكم في الدخول والتعامل مع التهديدات البحرية',
      ],
    },
    targetAudience: {
      fr: 'Commandants de ports, Officiers de sûreté, Directeurs des opérations portuaires, Cadres de la police maritime.',
      en: 'Harbor Masters, Security Officers, Terminal Operations Directors, Maritime Law Enforcement.',
      ar: 'قادة الموانئ، ضباط الأمن، مدراء العمليات المينائية والمختصون في النقل البحري.',
    },
  },
  {
    id: 'iso-27001-cyber',
    category: 'management',
    duration: '4 Jours (32h)',
    format: 'online',
    level: 'intermediaire',
    nextSessionDate: '02 - 05 Juin 2025',
    title: {
      fr: 'Sécurité de l\'Information & Cybersécurité (ISO/IEC 27001:2022)',
      en: 'Information Security & Cyber Resilience (ISO/IEC 27001:2022)',
      ar: 'أمن وسرية المعلومات والصمود السيبراني (ISO/IEC 27001:2022)',
    },
    description: {
      fr: 'Apprenez à concevoir, déployer et auditer un Système de Management de la Sécurité de l\'Information (SMSI) conforme à la dernière version 2022 de la norme ISO 27001.',
      en: 'Learn to design, deploy, and audit an Information Security Management System (ISMS) adhering to the latest ISO/IEC 27001:2022 release.',
      ar: 'تعلم كيفية تصميم وتطبيق وتدقيق نظام إدارة أمن المعلومات (ISMS) وفق أحدث إصدار لمواصفة ISO 27001:2022.',
    },
    objectives: {
      fr: [
        'Analyser les 93 mesures de sécurité de l\'Annexe A (ISO 27002:2022)',
        'Évaluer les risques cyber et définir la Déclaration d\'Applicabilité (DDA)',
        'Assurer la conformité RGPD et la protection des actifs numériques critiques',
      ],
      en: [
        'Master the 93 security controls in Annex A (ISO 27002:2022)',
        'Assess cyber risks and construct Statement of Applicability (SoA)',
        'Ensure GDPR compliance and critical digital asset protection',
      ],
      ar: [
        'دراسة وتطبيق ضوابط الأمن الـ 93 في الملحق أ (ISO 27002:2022)',
        'تقييم المخاطر السيبرانية وإعداد بيان التطبيقية (SoA)',
        'حماية البيانات الحساسة وضمان استمرارية الخدمات الرقمية',
      ],
    },
    targetAudience: {
      fr: 'RSSI, DSI, Ingénieurs réseaux & systèmes, Responsables conformité et DPO.',
      en: 'CISOs, CIOs, Network & Security Engineers, Compliance Officers, and DPOs.',
      ar: 'مدراء أمن المعلومات، مسؤولو النظم المعلوماتية، ومهندسو الشبكات والأمن السيبراني.',
    },
  },
  {
    id: 'lean-green-belt',
    category: 'management',
    duration: '6 Jours (48h)',
    format: 'hybrid',
    level: 'expert',
    nextSessionDate: '16 - 21 Juin 2025',
    title: {
      fr: 'Lean Six Sigma Green Belt - Excellence Opérationnelle & DMAIC',
      en: 'Lean Six Sigma Green Belt - Operational Excellence & DMAIC',
      ar: 'الحزام الأخضر في لين 6 سيجما والتميز التشغيلي منهجية DMAIC',
    },
    description: {
      fr: 'Formation pratique orientée résultats pour piloter des projets d\'amélioration de la performance, réduire les rebuts et maximiser la rentabilité.',
      en: 'Results-driven practical training to lead process improvement projects, eliminate operational waste, and maximize business profitability.',
      ar: 'دورة تطبيقية عملية لقيادة مشاريع تحسين الأداء، خفض التكاليف والهدر وزيادة ربحية وكفاءة المؤسسة.',
    },
    objectives: {
      fr: [
        'Maîtriser la démarche DMAIC (Définir, Mesurer, Analyser, Innover, Contrôler)',
        'Utiliser les outils statistiques et la cartographie VSM',
        'Conduire des chantiers 5S, SMED, Kaizen et gestion visuelle',
      ],
      en: [
        'Master DMAIC roadmap (Define, Measure, Analyze, Improve, Control)',
        'Utilize statistical analysis tools and Value Stream Mapping (VSM)',
        'Lead 5S, SMED, Kaizen, and visual management workshops',
      ],
      ar: [
        'إتقان مراحل منهجية DMAIC (التعريف، القياس، التحليل، التحسين، التحكم)',
        'استخدام الأدوات الإحصائية ورسم خرائط تدفق القيمة VSM',
        'تطبيق أدوات كايزن، 5S، وتقليل أوقات التبديل SMED',
      ],
    },
    targetAudience: {
      fr: 'Directeurs d\'usines, Responsables production, Ingénieurs méthodes, Chefs de projet performance.',
      en: 'Plant Managers, Production Heads, Industrial Engineers, Operational Excellence Leads.',
      ar: 'مدراء المصانع، مسؤولو الإنتاج، مهندسو الطرق والمناهج، وقادة مشاريع التطوير.',
    },
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    authorName: 'M. Belkacem Hadji',
    role: 'Directeur Général Adjoint QHSE',
    company: 'Groupe Industriel Sidérurgique',
    rating: 5,
    text: {
      fr: 'L\'accompagnement de Chérif Haddad Consulting & Expertise a été déterminant pour l\'obtention de notre triple certification ISO 9001 / 14001 / 45001. Rigueur, pédagogie et disponibilité sans faille.',
      en: 'The guidance provided by Chérif Haddad Consulting & Expertise was instrumental in securing our triple ISO 9001 / 14001 / 45001 certification. Unrivaled rigor, pedagogy, and commitment.',
      ar: 'كانت مرافقة مكتب شريف حداد للاستشارات والخبرة حاسمة في حصولنا على الشهادة الثلاثية للآيزو 9001 / 14001 / 45001. دقة ومنهجية واحترافية عالية.',
    },
  },
  {
    id: 't2',
    authorName: 'Ing. Claire Vasseur',
    role: 'Responsable Sûreté Maritime',
    company: 'Terminal Portuaire International',
    rating: 5,
    text: {
      fr: 'La formation ASIP / Code ISPS dispensée par M. Chérif Haddad est d\'un niveau exceptionnel. Les exercices pratiques et la simulation d\'audits réels font toute la différence.',
      en: 'The PFSO / ISPS Code training delivered by Mr. Chérif Haddad is world-class. Real-life simulations and practical audit exercises make all the difference.',
      ar: 'التدريب على أمن الموانئ ومدونة ISPS بإشراف الأستاذ شريف حداد كان في قمة التميز. التمارين التطبيقية ومحاكاة عمليات التدقيق الحقيقية أعطت قيمة مضافة كبيرة.',
    },
  },
  {
    id: 't3',
    authorName: 'Tariq Al-Hashemi',
    role: 'Chief Risk Officer',
    company: 'MENA Logistics & Shipping Ltd',
    rating: 5,
    text: {
      fr: 'La plateforme de vérification en direct des certificats par QR Code apporte une sécurité et une crédibilité inestimables à nos équipes formées.',
      en: 'The real-time QR Code certificate verification system provides unmatched security and credibility for all our certified workforce.',
      ar: 'نظام التحقق الفوري من الشهادات عبر رمز QR يوفر أماناً ومصداقية استثنائية لكافة كوادرنا الحاصلين على الشهادات.',
    },
  },
];
